/// <reference path="../../typings/browser.d.ts" />
var Pro2;
(function (Pro2) {
    //
    // Underscore injection
    //
    var Underscore = (function () {
        function Underscore() {
        }
        Underscore.factory = function () {
            var f = function ($w) {
                return $w["_"];
            };
            f.$inject = ["$window"];
            return f;
        };
        return Underscore;
    }());
    Pro2.Underscore = Underscore;
})(Pro2 || (Pro2 = {}));
/// <reference path="../../typings/browser.d.ts" />
var Pro2;
(function (Pro2) {
    var ResourceResource = (function () {
        function ResourceResource() {
        }
        ResourceResource.factory = function () {
            var f = function ($rc) {
                return $rc("config/resource.json");
            };
            f.$inject = ["$resource"];
            return f;
        };
        return ResourceResource;
    }());
    Pro2.ResourceResource = ResourceResource;
})(Pro2 || (Pro2 = {}));
/// <reference path="../../typings/browser.d.ts" />
/// <reference path="application.ts" />
/// <reference path="ambients.ts" />
var Pro2;
(function (Pro2) {
    var DateString = (function () {
        function DateString(scope, window) {
            this._scope = scope;
            this._window = window;
        }
        DateString.factory = function () {
            return DateString;
        };
        DateString.prototype.getDateString = function (n) {
            var timeFormat;
            var dateFormat;
            var supportsLocales = true;
            try {
                timeFormat = new Intl.DateTimeFormat(this._window.navigator.userLanguage || this._window.navigator.language, { hour12: false, hour: "2-digit", minute: "2-digit" });
                dateFormat = new Intl.DateTimeFormat(this._window.navigator.userLanguage || this._window.navigator.language, { weekday: "long", year: "numeric", month: "long", day: "numeric" });
            }
            catch (e) {
                supportsLocales = false;
            }
            var currentDate = new Date(Date.UTC(st.getUTCFullYear(), st.getUTCMonth(), st.getUTCDate(), st.getUTCHours(), 0));
            switch (cmt) {
                case 64:
                    currentDate.setTime(currentDate.getTime() + n * 3600 * 1000);
                    break;
                case 128:
                    var radarTime = new Date();
                    radarTime.setSeconds(0);
                    radarTime.setMilliseconds(0);
                    radarTime.setTime(radarTime.getTime() - 60 * 60 * 4 * 1000);
                    if (radarTime.getMinutes() < 30) {
                        radarTime.setMinutes(0);
                    }
                    else {
                        radarTime.setMinutes(30);
                    }
                    currentDate.setTime(radarTime.getTime() + n * 10 * 60 * 1000);
                    break;
                default:
                    var s = this._scope.selectedResource.stepInMinutes;
                    currentDate.setTime(currentDate.getTime() + n * (s / 60) * 3600 * 1000 - (st.getUTCHours() % (s / 60)) * 3600 * 1000);
                    break;
            }
            if (supportsLocales) {
                return timeFormat.format(currentDate) + "  " + dateFormat.format(currentDate);
            }
            else {
                return currentDate.toLocaleTimeString(window.navigator.userLanguage || window.navigator.language, { hour12: false, hour: "2-digit", minute: "2-digit" }) + "  " +
                    currentDate.toLocaleDateString(window.navigator.userLanguage || window.navigator.language, { weekday: "long", year: "numeric", month: "long", day: "numeric" });
            }
        };
        DateString.$inject = ["$rootScope", "$window"];
        return DateString;
    }());
    Pro2.DateString = DateString;
})(Pro2 || (Pro2 = {}));
/// <reference path="../../typings/browser.d.ts" />
/// <reference path="ambients.ts" />
/// <reference path="resource.ts" />
/// <reference path="datestring.ts" />
var Pro2;
(function (Pro2) {
    //
    // application controller
    //
    var ApplicationController = (function () {
        function ApplicationController(scope, rc, underscore, dateString, resid) {
            var _this = this;
            this._scope = scope;
            this._underscore = underscore;
            this._resourceBoundaryPath = null;
            this._scope.resources = rc.query();
            this._scope.selectResID = function (resID) { return _this._selectResource(resID); };
            this._scope.getDateString = function (n) { return dateString.getDateString(n); };
            this._scope.download = function (mt) { return _this._download(mt); };
            this._scope.cleanAll = function () { return _this._cleanAll(); };
            this._scope.$on("start", function () { return _this._start(); });
            this._scope.$on("reset", function () { return _this._reset(); });
            this._scope.resources.$promise.then(function () { return _this._selectResource(resid); });
        }
        ApplicationController.factory = function () {
            return ApplicationController;
        };
        ApplicationController.prototype._selectResource = function (resID) {
            this._cleanAll();
            if (rs != resID && rs != 3 && rs != 5 && rs != 9 && rs != 26) {
                rt = rs;
            }
            rs = resID;
            $("#resIDSelector").css({
                background: "url(pub/img/rc/" + rs + ".png)"
            });
            if (resID == 3) {
                $("#resIDSelector").css({
                    background: "url(pub/img/rc/2.png)"
                });
            }
            if (!(rs == 5 || rs == 3 || rs == 9 || rs == 26)) {
                closeResAreaDlg();
            }
            var r = this._underscore.findWhere(this._scope.resources, { id: resID });
            this._scope.selectedResource = r;
            // Ugly global!
            fn = r.frameCount;
            // switch to selected region
            this._adjustMap();
            // draw polilines
            this._drawResourceBoundary();
            // save settings
            settings.save();
        };
        ApplicationController.prototype._download = function (meteo) {
            if (meteo == 32) {
                this._selectResource(4);
                st = new Date();
                sf = (st.getUTCHours() < 7) ? (st.getUTCHours() + 24) : st.getUTCHours();
                cmt = 32;
            }
            else if (meteo == 128) {
                this._selectResource(26);
                sf = 0;
                cmt = 128;
            }
            else {
                st = new Date();
                if (meteo == 64) {
                    this._selectResource(9);
                    sf = (st.getUTCHours() < 7) ? st.getUTCHours() + 24 : st.getUTCHours();
                }
                else if (rs == 3 || rs == 5 || rs == 9 || rs == 26) {
                    this._selectResource(rt);
                    sf = (st.getUTCHours() < 7) ? ((st.getUTCHours() + 24) / 3) | 0 : (st.getUTCHours() / 3) | 0;
                }
                else {
                    if (meteo == 129) {
                        this._selectResource(2);
                        meteo = 16;
                    }
                    var stepInMinutes = this._scope.selectedResource.stepInMinutes;
                    sf = (st.getUTCHours() < 7) ? ((st.getUTCHours() + 24) / (stepInMinutes / 60)) | 0 : (st.getUTCHours() / (stepInMinutes / 60)) | 0;
                }
                cmt = meteo;
            }
            keyScale.show(cmt);
            pbar.rebuild();
            pbar.show();
            animation.start(sf);
            downloader.start(sf);
            this._scope.$broadcast("rebuild");
            this._scope.$broadcast("start");
            this._scope.$broadcast("pbar_show");
            this._scope.$broadcast("pbar_setcurrent", sf);
        };
        ApplicationController.prototype._cleanAll = function () {
            animation.reset();
            downloader.reset();
            keyScale.hide();
            pbar.hide();
            this._scope.$broadcast("pbar_hide");
            if (weatherOverlay) {
                weatherOverlay.hide();
            }
            for (var i = 0; i < fn; ++i) {
                if (fr[i]) {
                    fr[i] = { w: null, o: null, p: null, sw: null, ne: null, i: null, x: null, y: null, z: null };
                }
            }
            this._reset();
        };
        ApplicationController.prototype._adjustMap = function () {
            var r = this._scope.selectedResource;
            if (map && map.getBounds() && r && r.bounds) {
                var rb = new google.maps.LatLngBounds(new google.maps.LatLng(r.bounds.rough.s, r.bounds.rough.w), new google.maps.LatLng(r.bounds.rough.n, r.bounds.rough.e));
                if (!map.getBounds().intersects(rb)) {
                    map.fitBounds(rb);
                }
            }
        };
        ApplicationController.prototype._drawResourceBoundary = function () {
            if (this._resourceBoundaryPath) {
                this._resourceBoundaryPath.setMap(null);
            }
            if (this._scope.selectedResource.showBounds && this._scope.selectedResource.bounds && this._scope.selectedResource.bounds.path) {
                var path = this._underscore.map(this._scope.selectedResource.bounds.path, function (p) {
                    return new google.maps.LatLng(p.lat, p.lon);
                });
                this._resourceBoundaryPath = new google.maps.Polygon({
                    paths: path,
                    strokeColor: "#FF0000",
                    strokeWeight: 1,
                    strokeOpacity: 0.5,
                    fillOpacity: 0.1,
                    zIndex: 1,
                    clickable: false
                });
                this._resourceBoundaryPath.setMap(map);
            }
        };
        ApplicationController.prototype._start = function () {
            if (this._resourceBoundaryPath) {
                this._resourceBoundaryPath.setOptions({ fillOpacity: 0 });
            }
        };
        ApplicationController.prototype._reset = function () {
            if (this._resourceBoundaryPath) {
                this._resourceBoundaryPath.setOptions({ fillOpacity: 0.1 });
            }
        };
        ApplicationController.$inject = ["$rootScope", "Resource", "Underscore", "DateString", "resid"];
        return ApplicationController;
    }());
    Pro2.ApplicationController = ApplicationController;
})(Pro2 || (Pro2 = {}));
/// <reference path="../../typings/browser.d.ts" />
/// <reference path="application.ts" />
/// <reference path="ambients.ts" />
var Pro2;
(function (Pro2) {
    var ProgressBarController = (function () {
        function ProgressBarController(scope, underscore, dateString) {
            var _this = this;
            this._scope = scope;
            this._underscore = underscore;
            this._dateString = dateString;
            this._scope.show = false;
            this._scope.items = null;
            this._scope.current = null;
            this._scope.cached = null;
            this._scope.failed = null;
            this._scope.$on("reset", function () { return _this._reset(); });
            this._scope.$on("rebuild", function () { return _this._rebuild(); });
            this._scope.$on("pbar_show", function () { return _this._show(); });
            this._scope.$on("pbar_hide", function () { return _this._hide(); });
            this._scope.$on("pbar_setcurrent", function (e, i) { return _this._setCurrent(i); });
            this._scope.$on("pbar_setcached", function (e, i) { return _this._setCached(i); });
            this._scope.$on("pbar_setfailed", function (e, i) { return _this._setFailed(i); });
            this._scope.click = function (id) { return _this._click(id); };
        }
        ProgressBarController.factory = function () {
            return ProgressBarController;
        };
        ProgressBarController.prototype._reset = function () {
            this._scope.show = false;
            this._scope.items = null;
            this._scope.current = null;
            this._scope.cached = null;
            this._scope.failed = null;
        };
        ProgressBarController.prototype._rebuild = function () {
            var _this = this;
            var res = this._scope.selectedResource;
            var fn = res.frameCount;
            var s = res.stepInMinutes;
            var g = this._getGroupSize(s);
            this._scope.items = this._underscore.map(this._underscore.range(fn), function (i) {
                return {
                    id: i,
                    clickid: i,
                    // the same thing
                    // if it's NEXRAD - the special case
                    // need some refactoring
                    dStart: (res.id != 26)
                        ? ((i * s) % (24 * 60) == 0)
                        : (i % 6 == 0),
                    gStart: (i * s) % g == 0,
                    title: _this._dateString.getDateString(i - sf)
                };
            });
            // if it's NEXRAD - the special case
            // need some refactoring
            this._scope.dEnd = (res.id != 26)
                ? (((fn - 1) * s) % (24 * 60) == 0)
                : ((fn - 1) % 6 == 0);
            this._scope.cached = [];
            this._scope.failed = [];
        };
        ProgressBarController.prototype._getGroupSize = function (s) {
            // default grouping is none
            var g = s;
            // if step is less than hour then goup by hour
            if (s < 60)
                g = s;
            // if step is 1 hour - grouyp by 3 hours
            if (s == 60)
                g = 180;
            // if step is 2 hours then group by 4 hour
            if (s == 120)
                g = 240;
            return g;
        };
        ProgressBarController.prototype._show = function () {
            this._scope.show = true;
        };
        ProgressBarController.prototype._hide = function () {
            this._scope.show = false;
        };
        ProgressBarController.prototype._setCurrent = function (i) {
            this._scope.current = i;
        };
        ProgressBarController.prototype._setCached = function (i) {
            this._scope.cached[i] = true;
        };
        ProgressBarController.prototype._setFailed = function (i) {
            this._scope.failed[i] = true;
        };
        ProgressBarController.prototype._click = function (id) {
            if (!this._scope.failed[id]) {
                animation.goto(id);
            }
        };
        ProgressBarController.$inject = ["$scope", "Underscore", "DateString"];
        return ProgressBarController;
    }());
    Pro2.ProgressBarController = ProgressBarController;
})(Pro2 || (Pro2 = {}));
/// <reference path="../../typings/browser.d.ts" />
/// <reference path="underscore.ts" />
/// <reference path="resource.ts" />
/// <reference path="application.ts" />
/// <reference path="progressbar.ts" />
/// <reference path="datestring.ts" />
var Pro2;
(function (Pro2) {
    angular.module("app", ["ngResource"])
        .factory("Underscore", Pro2.Underscore.factory())
        .factory("Resource", Pro2.ResourceResource.factory())
        .service("DateString", Pro2.DateString.factory())
        .controller("ApplicationController", Pro2.ApplicationController.factory())
        .controller("ProgressBarController", Pro2.ProgressBarController.factory());
})(Pro2 || (Pro2 = {}));
